import { LinearProgress } from '@mui/material';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

import { useCallback, useEffect, useState } from 'react';
import { FallbackElement } from './components/FallbackElement';

export default function RouterFallbackElement() {
  const error: any = useRouteError();
  console.log({ error, isRouteErrorResponse: isRouteErrorResponse(error) });
  const [readyError, setReadyError] = useState(false);

  const errorReload = useCallback((errorMsg: string, maxRetries = 1) => {
    const urlString = window.location.href;

    const url = new URL(urlString);
    const errRetries = parseInt(url.searchParams.get('errRetries') || '0');
    if (errRetries < maxRetries) {
      url.searchParams.set('errRetries', String(errRetries + 1));
      window.location.href = url.toString();
    } else {
      window.history.replaceState(null, '', url.pathname);
      console.error(`errorReload: ${errorMsg}`);
      setReadyError(true);
    }
  }, []);

  // if (isRouteErrorResponse(error)) {
  //   console.error('FallbackElement', { error });
  // }

  useEffect(() => {
    const id = setTimeout(() => {
      const errorMessage = error?.data?.message ?? error?.message ?? 'Unknown error';

      const isDeployError =
        errorMessage.includes('Failed to fetch dynamically imported module') ||
        errorMessage.includes('Importing a module script failed');

      if (isDeployError) {
        errorReload(`Error during page load, ${errorMessage}`);
      } else {
        setReadyError(true);
      }
    }, 50);

    return () => clearTimeout(id);
  }, [error, errorReload]);

  if (!readyError)
    return (
      <>
        <LinearProgress />
      </>
    );

  return <FallbackElement />;
}
